"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const vue_3 = require("vue");
const invoiceStore_1 = require("../../stores/invoice/invoiceStore");
const i18n_1 = require("../../common/i18n");
const ResponsiveTable_vue_1 = __importDefault(require("../../components/ResponsiveTable/ResponsiveTable.vue"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'InvoiceItems',
    setup(__props) {
        var _a, _b, _c, _d, _e, _f, _g;
        const invoiceStore = (0, invoiceStore_1.useInvoiceStore)();
        const invoiceItemListFields = (0, vue_3.ref)([
            {
                key: "id",
                label: (_a = (0, i18n_1.trans)("item_id", "Item ID", "invoice_items")) !== null && _a !== void 0 ? _a : "Item ID",
                value: "id",
            },
            {
                key: "name",
                label: (_b = (0, i18n_1.trans)("name", "Name", "invoice_items")) !== null && _b !== void 0 ? _b : "Name",
                value: "name",
            },
            {
                key: "quantity",
                label: (_c = (0, i18n_1.trans)("quantity", "Quantity", "invoice_items")) !== null && _c !== void 0 ? _c : "Quantity",
                value: "quantity",
            },
            {
                key: "salesUnit",
                label: (_d = (0, i18n_1.trans)("sales_unit", "Sales Unit", "invoice_items")) !== null && _d !== void 0 ? _d : "Sales Unit",
                value: "salesUnit",
            },
            {
                key: "netAmount",
                label: (_e = (0, i18n_1.trans)("net_amount", "Net Amount", "invoice_items")) !== null && _e !== void 0 ? _e : "Net Amount",
                value: "netAmount",
            },
            {
                key: "vatAmount",
                label: (_f = (0, i18n_1.trans)("vat_amount", "Vat Amount", "invoice_items")) !== null && _f !== void 0 ? _f : "Vat Amount",
                value: "vatAmount",
            },
            {
                key: "grossAmount",
                label: (_g = (0, i18n_1.trans)("gross_amount", "Gross Amount", "invoice_items")) !== null && _g !== void 0 ? _g : "Gross Amount",
                value: "grossAmount",
            },
        ]);
        const selectedInvoiceItems = (0, vue_3.computed)(() => invoiceStore.getInvoiceItems);
        return (_ctx, _cache) => {
            return ((0, vue_2.unref)(selectedInvoiceItems).length > 0)
                ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(ResponsiveTable_vue_1.default, {
                    key: 0,
                    fields: invoiceItemListFields.value,
                    "onUpdate:fields": _cache[0] || (_cache[0] = ($event) => ((invoiceItemListFields).value = $event)),
                    items: (0, vue_2.unref)(selectedInvoiceItems),
                    striped: "",
                    condensed: "",
                    panel: ""
                }, {
                    "cell-quantity": (0, vue_2.withCtx)(({ item: invoiceItem }) => [
                        (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)(invoiceItem.quantity), 1)
                    ]),
                    "cell-netAmount": (0, vue_2.withCtx)(({ item: invoiceItem }) => [
                        (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)(invoiceItem.formattedNetAmount), 1)
                    ]),
                    "cell-vatAmount": (0, vue_2.withCtx)(({ item: invoiceItem }) => [
                        (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)(invoiceItem.formattedVatAmount), 1)
                    ]),
                    "cell-grossAmount": (0, vue_2.withCtx)(({ item: invoiceItem }) => [
                        (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)(invoiceItem.formattedGrossAmount), 1)
                    ]),
                    _: 1
                }, 8, ["fields", "items"]))
                : (0, vue_2.createCommentVNode)("", true);
        };
    }
});
